// ---Framework imports
import {isArray} from 'ldash'
import log from 'uix/logging'
import {formatDateTime} from 'uix/utils'

const TIME_FMT = /\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}\.?\d*/
let TIME = new RegExp(TIME_FMT)
export const MULTILINE_PREFIX = '\n'

export const XCHAN = 'uix'
export const uixmsg = msg => `${formatDateTime(new Date(), 'ISO')}.000 ${XCHAN} INTEREST ${msg}`

export const channelMatcher = pattern => new RegExp(TIME_FMT + ' \\w*\\.\\w*' + pattern + '\\w*')

export const aggregateLines = lines => {
  /* combine tracebacks (and other multiline log msgs) into a single line
  multiline messages will be flagged with a leading \n
   */
  let new_lines = []
  let line_collect = [MULTILINE_PREFIX]
  lines.forEach(l => {
    if (l.match(TIME)) {
      if (line_collect.length > 1) {
        new_lines.push(line_collect.join('\n'))
        line_collect = [MULTILINE_PREFIX]
      }
      new_lines.push(l)
    } else {
      line_collect.push(l)
    }
  })
  if (line_collect.length > 1) {
    new_lines.push(line_collect.join('\n'))
  }
  return new_lines
}

export const applyChannelFilter = (lines, line_filter) => {
  /* line_filter is a list of regexp statements (OR relation)
  or a single regexp
   */
  let annotated = null
  if (isArray(line_filter)) {
    annotated = lines.map(line => [line, line_filter.some(lf => line.match(lf))])
  } else {
    annotated = lines.map(line => [line, line.match(line_filter)])
  }

  let filtered_lines = []
  // also add non-loglines like tracebacks
  annotated.forEach(([line, is_filtered], i) => {
    if (is_filtered) {
      let prev_line = annotated[i - 1]
      if (prev_line && !prev_line[1] && line.startsWith(MULTILINE_PREFIX)) {
        // always add prev logline if match in multiline
        filtered_lines.push(prev_line[0])
      }

      filtered_lines.push(line)

      let next_line = annotated[i + 1]
      if (next_line && !next_line[1] && next_line[0].startsWith(MULTILINE_PREFIX)) {
        // always add next multiline
        filtered_lines.push(next_line[0])
      }
    }
  })

  return filtered_lines
}
